export default "__VITE_ASSET__gPlgCVum__"